import { type LoginResponse } from '@framework/api-client/api/auth/schemas/loginResponse.ts';
import { type RouteHistory } from '@framework/ui/core/pagination/paginationUrlQuery.ts';
import { message } from 'antd';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AuthActions } from '../../state/AuthSlice.tsx';

/**
 *  Custom hook per il login centralizzato
 * @param history
 * @returns
 */
export function useLogin(history: RouteHistory<any>) {
  const dispatch = useDispatch();

  const onLogin = useCallback(
    (result: LoginResponse) => {
      if (!result.accessToken || !result.refreshToken) {
        console.error('Errore durante il login', result);
        // biome-ignore format: <tbd>
        message.error(
          'Si è verificato un errore durante il login, nessun access token fornito.',
        );
        return;
      }
      dispatch(
        AuthActions.loginSucceed({
          strategy: 'jwt',
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
        }),
      );
      history.push('/');
    },
    [dispatch, history],
  );

  return onLogin;
}
